import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachInvoiceComponent } from '../attach-invoice/attach-invoice.component';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastrService } from 'ngx-toastr';
import  moment from 'moment' 
interface PortInvoiceItem {
  subtype?: string;
  createddate?: string;
  invoicefeetype?: string | null;
  status?: string;
}

@Component({
  selector: 'app-port-invoice',
  imports: [CommonModule, I18nModule],
  templateUrl: './port-invoice.component.html',
  styleUrls: ['./port-invoice.component.scss']
})
export class PortInvoiceComponent implements OnInit {
  @Input() batchData: any;
  @Input() useCaseType: 'SCREENINGINVOICE_UC3' | 'CARGOARRIVALINVOICE_UC3' | 'CARGODELIVERYINVOICE_UC3' = 'SCREENINGINVOICE_UC3';
  @Input() display: any;
  fromPortInvoice  = false;
  enableLoader = false;
  portInvoices: PortInvoiceItem[] = [];
  // isPortInvoicesFetchSuccess = false;
  errorMessage = '';

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    private customProfileService: CustomProfileService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.getPortInvoices();
  }

  onClose(): void {
    this.activeModal.dismiss('close');
  }

  openInvoices(data: any, invoice?: PortInvoiceItem) {
    this.activeModal.dismiss('open-attach-invoice');

      const modalref = this.modalService.open(AttachInvoiceComponent, {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
      });
      modalref.componentInstance.display = this.display;
      modalref.componentInstance.useCaseType = this.useCaseType || 'PORTARRIVALINVOICE_UC3';
      modalref.componentInstance.fromPortInvoice  = true;
      modalref.componentInstance.portInvoiceAction = invoice ? 'VIEW' : 'ADD';
      modalref.componentInstance.addedInvoices = this.portInvoices;
       if (invoice?.subtype) {
        modalref.componentInstance.batchData = { ...data, systemSubType: invoice.subtype };
        modalref.componentInstance.systemSubType = invoice.subtype;
        // modalref.componentInstance.isViewMode = this.isPortInvoicesFetchSuccess;
      } else {
        const batchDataForAdd = { ...(data || {}) };
        delete batchDataForAdd.systemSubType;
        modalref.componentInstance.batchData = batchDataForAdd;
        modalref.componentInstance.systemSubType = '';
      }
  }

  private buildPortInvoicePayload(): any {
    const batchId = this.batchData?.code || '';
    if (batchId) {
      return { batchId, useCaseType: this.useCaseType };
    }
    return {
      nomination: this.batchData?.nomination || this.batchData?.nominationNumber || '',
      nominationKey: this.batchData?.nominationKey || '',
      nominationKeyItem: this.batchData?.nominationKeyItem || this.batchData?.nominationItemNumber || '',
    };
  }

  private getPortInvoices(): void {
    const payload = this.buildPortInvoicePayload();
    if (!payload.batchId && (!payload.nomination || !payload.nominationKey || !payload.nominationKeyItem)) {
      this.errorMessage = 'Missing nomination details.';
      return;
    }

    this.enableLoader = true;
    this.errorMessage = '';
    this.customProfileService.getPortInvoices(payload).subscribe({
      next: (response: any) => {
        this.enableLoader = false;
        if (response?.status === 'SUCCESS') {
          this.portInvoices = Array.isArray(response?.data) ? response.data : [];
         
          // this.portInvoices.forEach(invoice => {
          //   if(invoice.status  === 'Success'){
          //     this.isPortInvoicesFetchSuccess = true;
          //   }
          // });
        } else {
          this.portInvoices = [];
          this.errorMessage = response?.message || 'Failed to retrieve port invoices.';
          this.toastrService.show(this.errorMessage);
        }
      },
      error: (error: any) => {
        this.enableLoader = false;
        this.portInvoices = [];
        this.errorMessage = error?.error?.message || 'Failed to retrieve port invoices.';
        this.toastrService.show(this.errorMessage);
      }
    });
  }
  
transformDate(date:any){
    return moment(date).format('DD/MM/YYYY');
  }
}

